var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-center":"","id":"devtool"}},[_c('v-flex',{attrs:{"xs5":""}},[_c('FindAndDelete',{attrs:{"instantEmailSearch":_vm.instantEmailSearch}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }